import React, { useEffect, useState } from "react";
import "./group.css";
import { Camera, Video } from "lucide-react";
import apiServiceHandler from "../../../service/apiService";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import ReactPlayer from "react-player";
import { handleUnreadGroupNotifications, updatePosts } from "../../../redux/groupData";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../../Spinner/Spinner";
import { getColorFromName } from "../../../utils/getColor";
import {
  collection,
  query,
  orderBy,
  onSnapshot,
  addDoc,
  doc,
  setDoc,
  updateDoc,
  getDoc,
  arrayUnion,
  serverTimestamp,
} from "firebase/firestore";
import { firestore } from "../../../firebase";

const GroupPost = ({ groupId }) => {
  const [isPopoverVisible, setPopoverVisible] = useState(false);
  const [photo, setPhoto] = useState(null);
  const [video, setVideo] = useState(null);
  const [content, setContent] = useState("");
  const [previewImage, setPreviewImage] = useState(null);
  const [previewVideo, setPreviewVideo] = useState(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch()
  const userDetails = JSON.parse(localStorage.getItem('userDetails'))
  const userName = useSelector((state) => state.userData?.userDetails?.name);
  const groupMembers = useSelector((state) => state.groupData?.groupInfo?.members);
  // const userDetails = useSelector(state => state.userData?.userDetails) || '';

  const handleInputFocus = () => {
    setPopoverVisible(true);
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    setPhoto(file);

    const imageUrl = URL.createObjectURL(file);
    setPreviewImage(imageUrl);
  };

  const handleVideoUpload = (e) => {
    const file = e.target.files[0];
    const fileSize = Math.floor(file.size / 1000000)
    if (fileSize > 100) {
      toastr.error("File size exceeds 100MB. Please upload a file smaller than 100MB.")
      setPopoverVisible(false);
      return 
    }
    setVideo(file);

    const videoUrl = URL.createObjectURL(file);
    setPreviewVideo(videoUrl);
  };

  const handleContentChange = (e) => {
    const textarea = e.target
    setContent(e.target.value);

    textarea.style.height = "auto";
    textarea.style.height = `${textarea.scrollHeight}px`;
  };

  const createPost = async () => {
    setLoading(true);
    const data = new FormData();
    data.append("file", photo ?? video ?? null);
    data.append("content", content);
    data.append("groupId", groupId);
    data.append("mediaType", photo ? "image" : video ? "video" : "text");
    data.append("status", 1);

    try {
      const response = await apiServiceHandler("POST", "api/post", data);
      toastr.success(response.message);
      dispatch(updatePosts(true));
      const textarea = document.querySelector(".textarea-input");
      if (textarea) {
        textarea.style.height = ""; 
      }

      setLoading(false);
      setContent("");
      setPhoto(null);
      setVideo(null);
      setPreviewImage(null);
      setPreviewVideo(null);
      setPopoverVisible(false);

      const members = [];
      groupMembers?.map((member) => {
        if (userDetails?._id === member) {
          members.push({ id: member, seen: true });
        } else {
          members.push({ id: member, seen: false });
        }
      });

      // firebase functions

      const docRef = doc(firestore, "communities", groupId);
      const postsRef = collection(docRef, "posts");

      const body = {
        content: (video || photo) ? "new post content" : content,
        group: groupId,
        lastSeen: members,
        postedBy: userName
      }

      await addDoc(postsRef, body);

      const communityRef = doc(firestore, "communities", groupId);

      await setDoc(
        communityRef,
        {
          lastMessageTimestamp: serverTimestamp(),
        },
        { merge: true }
      );

      for (const userId of groupMembers) {
        const userRef = doc(firestore, "notifs", userId);
        // Fetch the current notifications document to check if the notification exists
        const userDoc = await getDoc(userRef);
        if (userDoc.exists()) {
          const data = userDoc.data();
          const notifications = data.notifications || [];
          // Check if the notification with the same chatId already exists
          const existingNotification = notifications.find(
            (notification) => notification.groupId === groupId
          );

          console.log(existingNotification, 'existingNotification')
          if (existingNotification) {
            // If the notification exists, update the timestamp and read status
            const updatedNotifications = notifications.map((notification) =>
              notification.groupId === groupId
                ? {
                    ...notification,
                    timestamp: Date.now(),
                    read: userDetails?._id !== userId ? false : true,
                  } // Update the existing notification
                : notification
            );
            console.log(updatedNotifications, 'existingNotification--1')
            // Update the notifications array in the Firestore document
            await updateDoc(userRef, {
              notifications: updatedNotifications,
            });

            console.log("Notification updated successfully.");
          } else {
            // If the notification doesn't exist, add a new one using arrayUnion
            await setDoc(
              userRef,
              {
                notifications: arrayUnion({
                  groupId: groupId,
                  timestamp: Date.now(),
                  read: userDetails?._id !== userId ? false : true,
                }),
              },
              { merge: true }
            );

            console.log("New notification added.");
          }
        } else {
          // If no notifications document exists, create one with the new notification
          await setDoc(
            userRef,
            {
              notifications: [
                {
                  groupId: groupId,
                  timestamp: Date.now(),
                  read: userDetails?._id !== userId ? false : true,
                },
              ],
            },
            { merge: true }
            
          );

          console.log("Notification document created with new notification.");
        }
      }

    } catch (error) {
      toastr.error("Failed to Publish the Post. Please Try Again");
    } finally {
      setLoading(false);
      setContent("");
      setPhoto(null);
      setVideo(null);
      setPreviewImage(null);
      setPreviewVideo(null);
      setPopoverVisible(false);
    }
  };

  const clearPost = () => {
    setContent("");
    setPhoto(null);
    setVideo(null);
    setPreviewImage(null);
    setPreviewVideo(null);
    setPopoverVisible(false);
  };

  const updateReadStatus = async () => {
    const userId = groupMembers?.find((id) => id === userDetails?._id);
    if (!userId) return;

    const userRef = doc(firestore, "notifs", userId);
    const userDoc = await getDoc(userRef);

    if (userDoc.exists()) {
      const data = userDoc.data();
      const notifications = data.notifications || [];

      const existingNotification = notifications.find(
        (notification) => notification.groupId === groupId
      );

      
      if (existingNotification && !existingNotification.read) {
        const updatedNotifications = notifications.map((notification) =>
          notification.groupId === groupId
            ? { ...notification, read: true }
            : notification
        );

        dispatch(handleUnreadGroupNotifications(updatedNotifications));

        await updateDoc(userRef, { notifications: updatedNotifications });
      }
    }
  };

  useEffect(() => {
    updateReadStatus()
  }, [])

  return (
    <div className="group-post">
      <div className="group-post-composer">
        <div className="group-post-composer-avatar">
          <div className="avatar" style={{ background: getColorFromName(userDetails?.name) }}>
            <div className="avatar-text">{userDetails && userDetails.image ? (
              <img
                className="avatar__image"
                src={userDetails.image}
                alt="User Avatar"
              />
            ) : (
              <div className="user__avatar">
                {userDetails?.name.substr(0, 1)}
              </div>
            )}</div>
          </div>
        </div>
        <div className="group-post-composer-right">
          <div className="group-post-composer-preview">
            <div className="group-post-composer-media">
              {photo && (
                <div className="group-post-composer__preview-container">
                  <div
                    className="group-post-composer__preview-image"
                    style={{ backgroundImage: `url(${previewImage})` }}
                  ></div>
                </div>
              )}

              {video && (
                <div className="group-post-composer__preview-container">
                  {/* Use ReactPlayer to display the video */}
                  <ReactPlayer
                    url={previewVideo}
                    controls
                    width="100%"
                    height="auto"
                  />
                </div>
              )}
            </div>
            <div className="group-post-composer-text">
              <div className="group-post-composer-input">
                <div className="input-wrapper">
                  <textarea
                    type="text"
                    className="textarea-input"
                    placeholder="Write a post, press enter to publish..."
                    value={content}
                    onChange={handleContentChange}
                    onFocus={handleInputFocus}
                    style={{
                      resize: "none",
                      overflow: "hidden",
                    }}
                  />
                </div>
              </div>
            </div>
            {isPopoverVisible && (
              <>
                <div
                  className="group-post-composer-popover"
                  style={photo || video ? { display: "none" } : {}}
                >
                  <div className="group-post-composer-label">Add:</div>

                  {/* Photo Upload */}
                  <div className="file-input">
                    <div className="file-input-activator">
                      <label
                        htmlFor="photo-upload"
                        className="file-input-button"
                      >
                        <span className="file-input-icon">
                          <Camera />
                        </span>
                        <span className="btn-label">Photo</span>
                      </label>
                      <input
                        id="photo-upload"
                        type="file"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={handleImageUpload}
                      />
                    </div>
                  </div>

                  {/* Video Upload */}
                  <div className="file-input">
                    <div className="file-input-activator">
                      <label
                        htmlFor="video-upload"
                        className="file-input-button"
                      >
                        <span className="file-input-icon">
                          <Video />
                        </span>
                        <span className="btn-label">Video</span>
                      </label>
                      <input
                        id="video-upload"
                        type="file"
                        accept=".mp4, .mkv, .avi, .mov, .flv, .wmv, .webm, .m4v"
                        style={{ display: "none" }}
                        onChange={handleVideoUpload}
                      />
                    </div>
                  </div>
                </div>

                {/* Publish Button */}
                <div className="group-post-composer-footer">
                  <button
                    className="group-post-cancel-button"
                    onClick={clearPost}
                  >
                    <span className="group-post-label">Cancel</span>
                  </button>
                  <button
                    className="group-post-composer-button"
                    onClick={createPost}
                    disabled={loading}
                    style={loading ? { backgroundColor: '#268bd9', border: 'none' } : {}}
                  >
                    <span className="group-post-label">{loading ? "Publishing" : "Publish"}</span>
                    {loading && <Spinner />}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupPost;
